namespace RecordShield.Workspace {
    export class SerialKeyDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Workspace.SerialKeyDetails';

    }

    export interface SerialKeyDetailsForm {
        SerialKey: Serenity.StringEditor;
        Code: Serenity.IntegerEditor;
        Name: Serenity.StringEditor;
        Status: Serenity.EnumEditor;
        TenantName: Serenity.StringEditor;
        CreatedOn: Serenity.DateEditor;
        UserId: Serenity.IntegerEditor;
        Username: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        Mobile: Serenity.StringEditor;
        CurrentDeviceType: Serenity.StringEditor;
        FacultyEmail: Serenity.StringEditor;
        FacultyMobile: Serenity.StringEditor;
        Publisher: Serenity.IntegerEditor;
        PublisherName: Serenity.StringEditor;
        SupportInfo: Serenity.StringEditor;
        ValidFrom: Serenity.DateEditor;
        ValidTo: Serenity.DateEditor;
        ActivationDate: Serenity.DateEditor;
        ActivationDeviceType: Serenity.StringEditor;
        ActivationSysInfo: Serenity.StringEditor;
        Log: Serenity.StringEditor;
    }

    [['SerialKey', () => Serenity.StringEditor], ['Code', () => Serenity.IntegerEditor], ['Name', () => Serenity.StringEditor], ['Status', () => Serenity.EnumEditor], ['TenantName', () => Serenity.StringEditor], ['CreatedOn', () => Serenity.DateEditor], ['UserId', () => Serenity.IntegerEditor], ['Username', () => Serenity.StringEditor], ['DisplayName', () => Serenity.StringEditor], ['Email', () => Serenity.StringEditor], ['Mobile', () => Serenity.StringEditor], ['CurrentDeviceType', () => Serenity.StringEditor], ['FacultyEmail', () => Serenity.StringEditor], ['FacultyMobile', () => Serenity.StringEditor], ['Publisher', () => Serenity.IntegerEditor], ['PublisherName', () => Serenity.StringEditor], ['SupportInfo', () => Serenity.StringEditor], ['ValidFrom', () => Serenity.DateEditor], ['ValidTo', () => Serenity.DateEditor], ['ActivationDate', () => Serenity.DateEditor], ['ActivationDeviceType', () => Serenity.StringEditor], ['ActivationSysInfo', () => Serenity.StringEditor], ['Log', () => Serenity.StringEditor]].forEach(x => Object.defineProperty(SerialKeyDetailsForm.prototype, <string>x[0], { get: function () { return this.w(x[0], (x[1] as any)()); }, enumerable: true, configurable: true }));
}
